package nl.volleyplanner.web.controller.members

import kotlinx.coroutines.CoroutineScope
import kotlinx.coroutines.Deferred
import kotlinx.coroutines.Dispatchers
import kotlinx.coroutines.await
import kotlinx.coroutines.flow.StateFlow
import kotlinx.coroutines.launch
import kotlinx.html.TagConsumer
import kotlinx.html.div
import kotlinx.html.span
import nl.volleyplanner.api.GroupType
import nl.volleyplanner.web.base.HTMLComponent
import nl.volleyplanner.web.base.component.BootstrapButtonStyle
import nl.volleyplanner.web.base.component.iconButton
import nl.volleyplanner.web.controller.LedenController
import org.w3c.dom.HTMLElement
import kotlin.collections.map
import kotlin.collections.orEmpty
import kotlin.js.Promise

class PersonRecordLine(
    val personRecord: LedenController.PersonRecord,
    private val personEditModal: Deferred<PersonEditModal>,
    private val editable: Boolean
) : HTMLComponent() {
    override fun render(consumer: TagConsumer<HTMLElement>): HTMLElement {
        return consumer.div(classes = "row mx-0 py-2 border-bottom hover-bg-light") {
            div(classes = "col-4 ps-3") {
                if (editable) {
                    iconButton(buttonStyle = BootstrapButtonStyle.Secondary, "bi-pencil-square") { event ->
                        event.preventDefault()
                        CoroutineScope(Dispatchers.Main).launch {
                            personEditModal.await().showModal(personRecord)
                        }
                    }
                }

                +personRecord.person.name
            }
            div(classes = "col-3") {
                val allTeams = personRecord.person.groups?.get(GroupType.Team.paramValue).orEmpty()
                val teamNames = if (personRecord.team != null) {
                    val primary = personRecord.team.name
                    val others = allTeams.map { it.name }.filter { it != primary }
                    listOf(primary) + others
                } else {
                    allTeams.map { it.name }
                }
                +teamNames.joinToString(", ")
            }
            div(classes = "col-2") {
                personRecord.refereeGroups.forEach { refereeGroup ->
                    span(classes = "badge bg-secondary me-1") { +refereeGroup.name }
                }
            }
            div(classes = "col-3") {
                personRecord.volunteerJobs.forEach { job ->
                    span(classes = "badge bg-secondary me-1") { +job.jobName }
                }
            }
        }
    }

    override suspend fun getState(): StateFlow<*>? = null
}